import { GroupModel } from 'models';

import { HttpClient } from 'core/api/client/HttpClient';
import { ApiRouteService } from 'core/api/services';

export class GroupClient {
  constructor(private httpClient: HttpClient) {
    this.getAll = this.getAll.bind(this);
    this.getById = this.getById.bind(this);
    this.create = this.create.bind(this);
    this.update = this.update.bind(this);
  }

  public async getAll() {
    const options = await this.httpClient.createStandardOptions('GET', null);
    const result = await this.httpClient.fetchAndParse<GroupModel[]>(fetch(`${ApiRouteService.getCompumedApiBaseRoute()}/api/groups`, options));
    return result;
  }

  public async getById(id: number) {
    const options = await this.httpClient.createStandardOptions('GET', null);
    const result = await this.httpClient.fetchAndParse<GroupModel>(fetch(`${ApiRouteService.getCompumedApiBaseRoute()}/api/groups/${id}`, options));
    return result;
  }

  public async create(group: GroupModel) {
    const options = await this.httpClient.createStandardOptions('POST', group);
    const result = await this.httpClient.fetchAndParse<number>(fetch(`${ApiRouteService.getCompumedApiBaseRoute()}/api/groups`, options));
    return result;
  }

  public async update(group: GroupModel) {
    const options = await this.httpClient.createStandardOptions('PUT', group);
    await this.httpClient.fetch(fetch(`${ApiRouteService.getCompumedApiBaseRoute()}/api/groups/`, options));
  }
}
